export const ADMIN_AUTHORIZED = "ADMIN_AUTHORIZED";
export const CLEAR_REDUX_STATE = "CLEAR_REDUX_STATE";
export const ADMIN_MASTER_LOADER = "  ADMIN_MASTER_LOADER";
export const ORDER_STATUS_UPDATE = "ORDER_STATUS_UPDATE";